import React from "react";
import { Grid, Box, Typography } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import HomeIcon from "@mui/icons-material/Home";
import { NotoSansJp } from "./TextStyle";
import DocumentMeta from "react-document-meta";
import { useInstagramPosts, InstaImage } from "./InstaImages";
import { useBranch, Navigate } from "./useBranch";

const StaffBlog: React.FC = () => {
  const isSmartphone = useMediaQuery("(max-width:767px)");
  // 動的に最新6件を取得
  const instaposts = useInstagramPosts(6);
  const state = useBranch();
  if (state.status === "loading") return null;
  if (state.status === "notfound") return <Navigate to="/" replace />;
  const branch = state.branch;

  const meta = {
    title: `${branch.roomName}｜スタッフブログ`,
    description: `${branch.roomName}のスタッフブログ。教室の様子やお知らせをInstagramの投稿からお届けします。`,
    canonical: `https://tht-group.co.jp/${branch.id}/staffblog`,
    meta: {
      charset: "utf-8",
      name: {
        keywords: [...branch.top.regionKeywords, "スタッフブログ", "体操教室"].join(","),
      },
    },
  };

  return (
    <DocumentMeta {...meta}>
    <Box sx={{ width: "100vw" }}>
      <Grid
        container
        sx={{
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box sx={{ width: "100vw" }}>
          <Grid
            container
            direction="column"
            sx={{
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Box sx={{ width: "100%", mt: isSmartphone ? "40px" : "100px" }}>
              <Grid
                container
                direction="column"
                sx={{
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Typography
                  component="h1"
                  sx={{
                    color: "#EDE52E",
                    fontSize: isSmartphone ? "20px" : "35px",
                    fontWeight: "bold",
                    pt: isSmartphone ? "0" : "50px",
                    mb: isSmartphone ? "10px" : "20px",
                    ...NotoSansJp,
                  }}
                >
                  {branch.roomName}｜スタッフブログ
                </Typography>

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#333333",
                    mb: "40px",
                  }}
                >
                  <HomeIcon fontSize="small" />
                  <Typography
                    sx={{ fontSize: isSmartphone ? "14px" : "16px", mx: 1 }}
                  >
                    {">"}
                  </Typography>
                  <Typography
                    sx={{
                      color: "#333333",
                      fontWeight: 500,
                      fontSize: isSmartphone ? "14px" : "16px",
                      ...NotoSansJp,
                    }}
                  >
                    スタッフブログ
                  </Typography>
                </Box>

                <Box
                  sx={{
                    width: "100%",
                    mt: isSmartphone ? "50px" : "120px",
                    mb: isSmartphone ? "50px" : "120px",
                  }}
                >
                  <Box
                    sx={{
                      maxWidth: "1150px",
                      mx: "auto",
                      position: "relative",
                    }}
                  >
                    <Grid
                      container
                      direction="row"
                      sx={{ justifyContent: "center", alignItems: "center" }}
                    >
                      {instaposts.map((image: InstaImage, index: number) => (
                        <Box
                          key={index}
                          sx={{
                            p: "0 20px",
                            boxSizing: "border-box",
                            mb: "50px",
                          }}
                        >
                          {/* 画像部分 */}
                          <Box
                            sx={{
                              position: "relative",
                              borderRadius: "16px",
                              overflow: "hidden",
                              aspectRatio: "3 / 2",
                              mb: "15px",
                              "&::after": {
                                content: '""',
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                backgroundColor: "rgba(0, 0, 0, 0.2)",
                                opacity: 0,
                                transition: "opacity 0.5s ease-in-out",
                              },
                              "&:hover::after": {
                                opacity: 1,
                              },
                            }}
                          >
                            <img
                              src={image.src}
                              alt={image.title}
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                borderRadius: "16px",
                                transition: "transform 0.5s ease-in-out",
                              }}
                            />
                          </Box>

                          {/* タイトル部分 */}
                          <Typography
                            sx={{
                              color: "#333333",
                              fontSize: "16px",
                              fontFamily: "'Noto Sans JP', Sans-serif",
                              fontWeight: 500,
                              lineHeight: "1.8em",
                              letterSpacing: "2px",
                              mb: "10px",
                            }}
                          >
                            {image.title
                              .split("[ICON]")
                              .map((part, i: number) => (
                                <React.Fragment key={i}>
                                  {i > 0 && (
                                    <img
                                      src={image.icon}
                                      alt="icon"
                                      style={{ width: "15px", height: "15px" }}
                                    />
                                  )}
                                  <span>{part}</span>
                                </React.Fragment>
                              ))}
                          </Typography>

                          {/* 日付部分 */}
                          <Typography
                            sx={{
                              color: "#333333",
                              fontSize: "14px",
                              fontFamily: "'Noto Sans JP', Sans-serif",
                              fontWeight: 500,
                              lineHeight: "1.8em",
                              letterSpacing: "2px",
                            }}
                          >
                            {image.date}
                          </Typography>
                        </Box>
                      ))}
                    </Grid>
                  </Box>
                </Box>
              </Grid>
            </Box>
          </Grid>
        </Box>
      </Grid>
    </Box>
    </DocumentMeta>
  );
};

export default StaffBlog;
